import { render, staticRenderFns } from "./GoArtToast.vue?vue&type=template&id=b0585a72&scoped=true"
import script from "./GoArtToast.vue?vue&type=script&lang=js"
export * from "./GoArtToast.vue?vue&type=script&lang=js"
import style0 from "./GoArtToast.vue?vue&type=style&index=0&id=b0585a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0585a72",
  null
  
)

export default component.exports